import { useI18nContext } from '../../locale/i18n-react';

export const useGetBooleanToYesNo = () => {
	const { LL } = useI18nContext();

	const booleanToYesNo = (value: boolean) =>
		value ? LL.common.yes() : LL.common.no();

	return booleanToYesNo;
};

export const useGetBooleanToYesNoNullable = () => {
	const booleanToYesNo = useGetBooleanToYesNo();

	const getBooleanToYesNoNullable = (value: boolean | undefined | null) => {
		if (value === undefined || value === null) return value;
		return booleanToYesNo(value);
	};
	return getBooleanToYesNoNullable;
};
